export const constant = {
  baseUrl:
    process.env.REACT_APP_BASE_URL || "https://crm.anzianoconsultants.com/",
  // baseUrl: 'https://newinsurance.onrender.com/'
};
